import { ReactComponent as IconCog } from "../../../layout/left_menu_icons/icon_menu_settings_active.svg";
import { ReactComponent as IconClear } from "../../../layout/others/icon_clear.svg";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import { useAdvanceSearchContext } from "./AdvanceSearchContext";

export function FilterSettings() {
  let { t } = useTranslation();

  function needtoLoadFilters() {
    if (filtersSettings.length === 0) loadFilters();
  }

  const {
    filtersSettings,
    deleteFilter,
    updateFilter,
    loadFilters
  } = useAdvanceSearchContext();

  return (
    <>
      <div>
        <IconCog
          title={t("choose stored filters")}
          onClick={needtoLoadFilters}
          className="dropdown-toggle"
          data-bs-toggle="dropdown"
          id="filtersettings"
        />
        <div className="dropdown-menu">
          <table className="table table-hover table-borderless">
            <tbody>
              <tr>
                <td colSpan="2">{t("stored filters...")}</td>
              </tr>
              {filtersSettings?.map((filter) => (
                <tr key={filter.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={filter.active}
                      onClick={(event) => updateFilter(event, filter.name)}
                    ></input>
                  </td>
                  <td>
                    <span>{t(filter.name)}</span>
                  </td>
                  <td>
                    <IconClear
                      title={t("Clear")}
                      onClick={(event) => deleteFilter(event, filter.name)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

FilterSettings.propTypes = {
  filters: PropTypes.array.isRequired,
  deleteFilter: PropTypes.func.isRequired
};
